import SVGButton from "../svgButton/SVGButton";

/** SVGアイコン種別 */
export const ICON_KEY = {
  MAXIMUM: 'maximum',
  MINIMUM: 'minimum',
  RESET_ZOOM: 'reset-zoom',
  CONFIG: 'config',
  CURSOR_A: 'cursor-a',
  CURSOR_B: 'cursor-b',
  MARKER: 'marker',
  SKIP_FORWARD_SHORT: 'skip-forward-short',
  SKIP_BACK_SHORT: 'skip-back-short',
  SKIP_FORWARD_LONG: 'skip-forward-long',
  SKIP_BACK_LONG: 'skip-back-long',
};

/** ボタン種別 */
export const BUTTON_TYPE = {
  RIGHT_TOP: 'right-top',
  MARKER: 'mark-btn',
  BOTTOM: 'bottom-btn',
  RIGHT_TOP_ABSOLUTE: 'right-top-absolute',
  BOTTOM_SMALL: 'bottom-btn-small',
};

const BASE_BTN_CLASS = 'no-text-svg-btn';

export default {
  name: 'NoTextSVGButton',

  extends: SVGButton,

  // 継承元からアイコン種別を追加
  data() {
    return {
      ICON_KEY: ICON_KEY
    };
  },

  watch: {
    class: {
      handler(newClass) {
        // クラスが変わったら再設定する
        this.setClass(newClass);
      },
    },
  },

  methods: {

    /**
     * クラスを設定する
     * @param {string} newClass クラス名
     */
    setClass(newClass) {
      if (newClass) {
        this.buttonClass = `${BASE_BTN_CLASS} ${newClass}`;
      } else {
        this.buttonClass = BASE_BTN_CLASS;
      }
    }
  },

  // 継承元からCSSのクラス設定処理を変更
  mounted() {
    this.setClass(this.class);
  }
};